import { faAngry, faFrown, faGrin, faMeh, faSmile } from '@fortawesome/pro-solid-svg-icons'
import { FeedbackRating } from '@citruscamps/citrus-client'

export interface FeedbackRatingDetails {
  id: FeedbackRating
  icon: any
  value: number
}

export const FeedbackRatingTypes: FeedbackRatingDetails[] = [
  { id: 'terrible', icon: faAngry, value: 1 },
  { id: 'bad', icon: faFrown, value: 2 },
  { id: 'okay', icon: faMeh, value: 3 },
  { id: 'good', icon: faSmile, value: 4 },
  { id: 'great', icon: faGrin, value: 5 },
]

export const getFeedbackRating = (
  rating: FeedbackRating | number,
): FeedbackRatingDetails | undefined => {
  return typeof rating === 'number'
    ? FeedbackRatingTypes.find((i) => i.value === rating)
    : FeedbackRatingTypes.find((i) => i.id === rating)
}

export const getAvergaeFeedbackRating = (
  ratings: { rating: FeedbackRating; amount: number }[],
): FeedbackRatingDetails | undefined => {
  const total: number = ratings.reduce<number>((t, i) => t + (i.amount || 0), 0)
  const avg: number | undefined =
    total && ratings.length > 0
      ? Math.round(
          ratings.reduce<number>(
            (t, i) =>
              t + i.amount * (FeedbackRatingTypes.find((t) => t.id === i.rating)?.value || 0),
            0,
          ) / total,
        )
      : undefined
  return FeedbackRatingTypes.find((i) => i.value === avg)
}
